import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { formatPrice, logPostHogEvent } from '@utils/index';
import diaperTypes from '@utils/constants/diaperTypes';
import { DealPostType } from '@types';

const getDiaperLabelByValue = (value: string) => {
  const diaper = diaperTypes.find((diaper) => diaper.value === value);
  return diaper ? diaper.label : '';
};

const getLowestPricePerDiaper = (deal: DealPostType): null | number => {
  if (!deal.qty || !deal.finalPrice || deal.qty === 0) {
    return null;
  }
  return deal.finalPrice / deal.qty;
};

const addSizeTermDeal = (
  sizeTermDeals: any[],
  deal: DealPostType,
  lowestPricePerDiaper: number | null
) => {
  sizeTermDeals.push({
    label: getDiaperLabelByValue(deal.sizeTerm),
    value: deal.sizeTerm,
    amount: 1,
    lowestPricePerDiaper
  });
};

const updateSizeTermDeal = (
  passedSizeTermDeal: any,
  deal: DealPostType,
  lowestPricePerDiaper: number | null
) => {
  const sizeTermDeal = passedSizeTermDeal;
  sizeTermDeal.amount += 1;
  if (
    lowestPricePerDiaper &&
    (!sizeTermDeal.lowestPricePerDiaper ||
      lowestPricePerDiaper < sizeTermDeal.lowestPricePerDiaper)
  ) {
    sizeTermDeal.lowestPricePerDiaper = lowestPricePerDiaper;
  }
};

const processDeal = (sizeTermDeals: any[], deal: DealPostType) => {
  const lowestPricePerDiaper = getLowestPricePerDiaper(deal);
  const existingDealIndex = sizeTermDeals.findIndex(
    (x) => x.value === deal.sizeTerm
  );

  if (existingDealIndex === -1) {
    addSizeTermDeal(sizeTermDeals, deal, lowestPricePerDiaper);
  } else {
    updateSizeTermDeal(
      sizeTermDeals[existingDealIndex],
      deal,
      lowestPricePerDiaper
    );
  }
};

const getSizeTermData = (deals: DealPostType[]) => {
  const sizeTermDeals: Array<{
    label: string;
    value: string;
    amount: number;
    lowestPricePerDiaper?: number | null;
  }> = [];

  deals.forEach((deal) => {
    if (deal.sizeTerm) {
      processDeal(sizeTermDeals, deal);
    }
  });

  sizeTermDeals.sort((a, b) => a.label.localeCompare(b.label));
  return sizeTermDeals;
};

const FilterBySize = ({
  deals,
  sizeFilter,
  setSizeFilter
}: {
  deals: DealPostType[];
  sizeFilter: string;
  setSizeFilter: (sizeFilter: string) => void;
}) => {
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="filter-by-size-label">Filter By Size</InputLabel>
      <Select
        labelId="filter-by-size-label"
        id="filter-by-size"
        value={sizeFilter}
        label="Filter By Size"
        onChange={(e) => {
          setSizeFilter(e.target.value as string);
          logPostHogEvent('page-deal-size-by-promotion', {
            value: e.target.value
          });
        }}
      >
        <MenuItem value="all">All Sizes</MenuItem>
        {getSizeTermData(deals || []).map((sizeTermData) => (
          <MenuItem key={sizeTermData.value} value={sizeTermData.value}>
            {`${sizeTermData.label} — From ${formatPrice(
              sizeTermData.lowestPricePerDiaper
            )}/diaper`}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterBySize;
